import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../Icon/Icon";
import { IconVariants } from "../../Images/Icon/constants";
import { BrandAvatarContainer, StyledBrandAvatar, StyledPlaceHolder, } from "./BrandAvatar.style";
import { BrandAvatarVariants, BrandAvatarSizes, } from "./constants";
const BrandAvatar = ({ brandSize = BrandAvatarSizes.small, variants = BrandAvatarVariants.original, imgUrl, iconName = "itaufonts_para_empresa", }) => {
    return (_jsx(BrandAvatarContainer, { children: imgUrl ? (_jsx(StyledBrandAvatar, { src: imgUrl, alt: "Brand Avatar", variants: variants, brandSize: brandSize })) : (_jsx(StyledPlaceHolder, { variants: variants, brandSize: brandSize, children: _jsx(Icon, { name: iconName, size: "medium", variant: IconVariants.neutral }) })) }));
};
export default BrandAvatar;
//# sourceMappingURL=BrandAvatar.js.map